var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol"},[_c('img',{attrs:{"src":require("../../assets/image/protocol/one.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/image/protocol/two.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/image/protocol/three.png"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/image/protocol/four.png"),"alt":""}})])
}]

export { render, staticRenderFns }